import { render, staticRenderFns } from "./activity-form-instruction-step-preview.vue?vue&type=template&id=17db2a12&scoped=true&"
import script from "./activity-form-instruction-step-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-instruction-step-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-instruction-step-preview.vue?vue&type=style&index=0&id=17db2a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17db2a12",
  null
  
)

component.options.__file = "activity-form-instruction-step-preview.vue"
export default component.exports